import App from './App';
import UnauthApp from './UnauthApp';

declare global {
  interface Window {
    App: any;
    createAccountData_email: string;
  }
}

export default App;

export { UnauthApp };
